export default function ReferralsLinkSkeleton(): JSX.Element {
  return (
    <div className="sk-referrals-link animate-pulse">
      <div className="sk-referrals-link__field"></div>
      <div className="sk-referrals-link__btn"></div>
    </div>
  );
}
